import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import { UseOptionsQueryParams, UseOptionsQueryReturnType } from '@/components/FilterNew/types';
import { GroupStatusEnum, GroupTypeEnum } from '@/types/schema';

import useFilterOptionsQuery from '../../hooks/useFilterOptionsQuery';
import { getGroupFilterOption, useUserGroupFilterValues } from '../user-group';
import { useUserGroupFilterQuery } from '../user-group/graphql/queries/generated/userGroupFilter';

const useOptionsQuery = ({ searchText }: UseOptionsQueryParams): UseOptionsQueryReturnType =>
  useFilterOptionsQuery({
    useQuery: useUserGroupFilterQuery,
    edgeKey: 'groups',
    variables: {
      filters: {
        name: searchText,
        status: [GroupStatusEnum.Published],
        systemGenerated: false,
        types: [GroupTypeEnum.ContentCollection],
      },
    },
    getFilterOption: getGroupFilterOption,
  });

export const CollectionEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useOptionsQuery,
  useFilterValues: useUserGroupFilterValues,
};
